import { memo } from 'react';

import { BzTabsContainer, BzTabsContent } from '../../../components';

const PlaceOrderContent = ({ arrPlaceOrderInfo, activeTabKey, isHeader }) => {
    return (
        <BzTabsContainer>
            {arrPlaceOrderInfo.map((each) => (
                each &&
                <BzTabsContent key={each.tabKey} tabKey={each.tabKey} showDefault={each.tabKey === activeTabKey} isActive={each.tabKey === activeTabKey} >{!isHeader?each.tableContent:each.tableHeader}</BzTabsContent>
            ))}
        </BzTabsContainer>
    );
};

export default memo(PlaceOrderContent);